import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AlignHorizontalCenter"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M18 13.5H12.75V10.5H15C15.3977 10.4995 15.7789 10.3413 16.0601 10.0601C16.3413 9.77891 16.4995 9.39767 16.5 9V6C16.4995 5.60233 16.3413 5.22109 16.0601 4.93989C15.7789 4.65869 15.3977 4.5005 15 4.5H12.75V1.5H11.25V4.5H9C8.60233 4.5005 8.22109 4.65869 7.93989 4.93989C7.65869 5.22109 7.5005 5.60233 7.5 6V9C7.5005 9.39767 7.65869 9.77891 7.93989 10.0601C8.22109 10.3413 8.60233 10.4995 9 10.5H11.25V13.5H6C5.60233 13.5005 5.22109 13.6587 4.93989 13.9399C4.65869 14.2211 4.5005 14.6023 4.5 15V18C4.5005 18.3977 4.65869 18.7789 4.93989 19.0601C5.22109 19.3413 5.60233 19.4995 6 19.5H11.25V22.5H12.75V19.5H18C18.3977 19.4995 18.7789 19.3413 19.0601 19.0601C19.3413 18.7789 19.4995 18.3977 19.5 18V15C19.4995 14.6023 19.3413 14.2211 19.0601 13.9399C18.7789 13.6587 18.3977 13.5005 18 13.5ZM9 6H15V9H9V6ZM18 18H6V15H18V18Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AlignHorizontalCenter.vue"]]);
